'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.FaresOptimizer.Common.FaresOptimizerFilingFilter', dependencies).factory('FaresOptimizerFilingLadderFilterService', require('./services/FaresOptimizerFilingLadderFilterService'));